<template>
  <div class="news-page">
    <div class="content">
      <h2>新闻中心</h2>
    </div>
    <div class="menu_content">
      <div v-for="(news, index) in newsList" :key="index" class="menu_ul">
        <div class="spec">
          <img src="../../assets/img/home/world.png" alt="" />
          <h3>{{ news.title }}</h3>
        </div>
        <p>
          {{ news.content }}
        </p>
        <div class="news-date">{{ news.date }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'News',
  data() {
    return {
      newsList: [
        {
          title: '游戏更新公告',
          date: '2024-03-20',
          content: '本次更新主要优化了游戏性能，修复了若干bug，并添加了新的游戏内容。'
        },
        {
          title: '新活动预告',
          date: '2024-03-19',
          content: '即将推出新的游戏活动，敬请期待！'
        },
        {
          title: '服务器维护通知',
          date: '2024-03-18',
          content: '服务器将于本周日进行例行维护，预计维护时间为2小时。'
        }
      ]
    }
  }
}
</script>

<style scoped>
.news-page {
  padding: 20px;
}

.content h2 {
  font-weight: 800;
  color: #000000;
  text-align: center;
}

.menu_content {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 1%;
}

.menu_ul {
  flex-basis: 49%;
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.menu_ul h3 {
  font-weight: 600;
  color: #494f51;
  line-height: 36px;
  margin-left: 6px;
}

.menu_ul img {
  max-width: 36px;
}

.spec {
  display: flex;
  align-items: center;
}

.menu_ul p {
  font-size: 14px;
  font-weight: 400;
  color: #919ca8;
  line-height: 24px;
  margin-top: 10px;
}

.news-date {
  font-size: 12px;
  color: #666;
  margin-top: 10px;
  text-align: right;
}

@media (max-width: 768px) {
  .menu_ul {
    flex-basis: 99%;
  }
}
</style> 